/* eslint-disable @typescript-eslint/no-explicit-any */
export function objToQueryString(obj: any) {
  const keyValuePairs = []
  for (let i = 0; i < Object.keys(obj).length; i += 1) {
    keyValuePairs.push(
      `${encodeURIComponent(Object.keys(obj)[i])}=${encodeURIComponent(
        (Object.values(obj) as any)[i],
      )}`,
    )
  }
  return keyValuePairs.join('&')
}
